import { withJsonFormsControlProps } from '@jsonforms/react';
import { CustomHtml } from './CustomHtml';

const CustomHtmlControl = ({ data, handleChange, path, schema, visible }) => {
  return (
    <CustomHtml
      value={data}
      updateValue={(newValue) => handleChange(path, newValue)}
      path={path}
      html={schema?.html ?? ''}
      visible={visible}
    />
  );
};

export default withJsonFormsControlProps(CustomHtmlControl);
